/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
    object, string, func,
} from 'prop-types';
import { useUIDSeed } from 'react-uid';
import { selectedSkuType, skuDataType } from '../common/types';

const styles = (theme) => ({
    clubSelectionBox: {
        width: 90,
        textAlign: 'center',
        display: 'inline-block',
        marginRight: 3,
        position: 'relative',
        border: '1.5px solid rgba(191, 191, 191, 1)',
        cursor: 'pointer',
        fontSize: '1em',
        minWidth: '40px',
        whiteSpace: 'nowrap',
        fontWeight: '700',
        borderRadius: '4px',
        marginBottom: '10px',
        textTransform: 'Capitalize',
        '&:hover': {
            border: '1.5px solid rgba(0, 0, 0, 1)',
        },
    },
    clubSelectionBoxSelected: {
        width: 90,
        border: '1.5px solid rgba(0,0,0, 1)',
        cursor: 'pointer',
        color: theme.palette.cms?.primary_font_color || '#ffffff',
        display: 'inline-block',
        background: theme.palette.common?.black || '#000',
        position: 'relative',
        textAlign: 'center',
        marginRight: 3,
        fontSize: '1em',
        minWidth: '40px',
        whiteSpace: 'nowrap',
        fontWeight: '700',
        borderRadius: '4px',
        marginBottom: '10px',
        textTransform: 'Capitalize',
        '&:hover': {
            border: '1.5px solid rgba(0, 0, 0, 1)',
        },
        '&:focus-visible': {
            outline: 'auto 1px -webkit-focus-ring-color',
        },
    },
    relative: {
        position: 'relative',
    },
    clubTagline: {
        position: 'absolute',
        backgroundColor: theme.palette.grey?.['300'] || '#E0E0E0',
        color: theme.palette.text?.primary || '#000',
        left: '-1px',
        padding: '3px',
        top: '8px',
        fontWeight: '600',
        fontStyle: 'italic',
        fontSize: '12px',
    },
    clubPrice: {
        margin: '10px 0',
        fontSize: '18px',
        fontWeight: '700',
        marginTop: '40px',
    },
    clubDuration: {
        margin: '10px 0',
        fontSize: '16px',
    },
    monthContainer: {
        display: 'flex',
    },
    clubSelectedMonth: {
        border: `1px solid ${theme.palette.cms?.clubSelectedMonth || '#161616'} !important`,
        backgroundColor: `${theme.palette.cms?.clubSelectedMonth || '#161616'} !important`,
        color: `${theme.palette.cms?.primary_font_color || '#ffffff'} !important`,
        '&:focus-visible': {
            outline: 'auto 1px -webkit-focus-ring-color',
        },
    },
    fadeClubMonth: {
        overflow: 'auto',
        width: '48px',
        border: `1px solid ${theme.palette.cms?.checkbox || '#797979'}`,
        padding: '5px 4px',
        fontSize: '1em',
        minWidth: '40px',
        fontWeight: '700',
        marginRight: '10px',
        borderRadius: '4px',
        marginBottom: '10px',
        textTransform: 'Capitalize',
        display: 'inline-block',
        textAlign: 'center',
        cursor: 'pointer',
        backgroundColor: theme.palette.cms?.primary_font_color || '#ffffff',
        opacity: 0.4,
        '&:focus-visible': {
            outline: 'auto 1px -webkit-focus-ring-color',
        },
    },
    clubmonth: {
        overflow: 'auto',
        width: '48px',
        border: `1px solid ${theme.palette.cms?.checkbox || '#797979'}`,
        padding: '5px 4px',
        fontSize: '1em',
        minWidth: '40px',
        fontWeight: '700',
        marginRight: '10px',
        borderRadius: '4px',
        marginBottom: '10px',
        textTransform: 'Capitalize',
        display: 'inline-block',
        textAlign: 'center',
        cursor: 'pointer',
        backgroundColor: theme.palette.cms?.primary_font_color || '#ffffff',
        '&:hover': {
            border: '1px solid rgba(0, 0, 0, 1)',
        },
        '&:focus-visible': {
            outline: 'auto 1px -webkit-focus-ring-color',
        },
    },
    upsellContainer: {
        display: 'flex',
        maxWidth: '100%',
        justifyContent: 'center',
    },
    upsellsLabelItalic: {
        fontStyle: 'italic',
        color: theme.palette.cms?.clubAvailablility || '#404040',
    },
    blockRemove: {
        background: `${theme.palette.primaryButton || '#a1001a'}!important`,
    },
    upsellBox: {
        width: 144,
        position: 'relative',
        marginRight: 35,
        '& > img': {
            maxWidth: '100%',
        },
        cursor: 'pointer',
        '&:hover span.unselected': {
            background: theme.palette.primaryButton || '#a1001a',
            '& span.priceBlock': {
                display: 'none !important',
            },
            '& span.seeMore': {
                display: 'block',
            },
        },
        '& span.seeMore': {
            display: 'none',
        },
    },
    upsellPriceTag: {
        position: 'absolute',
        right: 0,
        left: 0,
        bottom: 0,
        backgroundColor: theme.palette.cms?.secondary || '#2f2f2f',
        boxSizing: 'border-box',
        color: theme.palette.cms?.primary_font_color || '#ffffff',
        padding: 2,
        textAlign: 'center',
    },
    prevLink: {
        transform: 'rotate(-90deg)',
        backgroundColor: 'rgba(255, 255, 255, 0)',
        boxSizing: 'border-box',
        color: theme.palette.desktopHeaderMenu?.text || '#333333',
        textAlign: 'center',
        lineHeight: 'normal',
        '&:focus-visible': {
            outline: 'auto 1px -webkit-focus-ring-color',
        },
    },
    nextLink: {
        transform: 'rotate(90deg)',
        backgroundColor: 'rgba(255, 255, 255, 0)',
        boxSizing: 'border-box',
        color: theme.palette.desktopHeaderMenu?.text || '#333333',
        textAlign: 'center',
        lineHeight: 'normal',
        '&:focus-visible': {
            outline: 'auto 1px -webkit-focus-ring-color',
        },
    },
    flexContainer: {
        display: 'flex',
    },
    productImageWrapperMonth: {
        flex: '1 1 auto',
        maxWidth: '300px',
        minWidth: '300px',
        height: '100%',
        position: 'relative',
        [theme.breakpoints.down('md')]: {
            order: '1',
        },
    },
    monthDescriptionSummury: {
        minWidth: '500px',
        marginLeft: '50px',
    },
    productImage: {
        width: '100%',
        height: 'auto',
        [theme.breakpoints.down('md')]: {
            height: 'auto',
        },
    },
    closeIcon: {
        position: 'absolute',
        top: '13px',
        right: '13px',
        cursor: 'pointer',
    },
    addToCartButtonFullWidth: {
        color: theme.palette.white,
        backgroundColor: `${theme.palette.primaryButton} !important`,
        fontFamily: theme.typography.fontFamily,
        boxSizing: 'border-box',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        fontWeight: '700',
        width: '100%',
        height: '50px',
        fontSize: '1em',
        textTransform: 'uppercase',
        borderRadius: '28px',
        lineHeight: '1.46em',
        padding: '7px 24px 5px 24px',
    },
    clubUpsellSelected: {
        background: theme.palette.cms?.selectedUpsellBackground || 'rgba(0,0,0,0.7)',
        position: 'absolute',
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        '& .delete-box': {
            display: 'none',
        },
        '&:hover': {
            '& .slected-box': {
                display: 'none',
            },
            '& .delete-box': {
                display: 'block',
            },
        },
    },
    block: {
        display: 'block',
        color: theme.palette.cms?.primary_font_color || '#ffffff',
        textAlign: 'center',
        '& img': {
            marginTop: 20,
        },
        '& img.remove': {
            marginTop: 50,
        },
    },
    selectionContainer: {
        marginTop: 25,
        width: '95%',
        margin: '0 auto',
    },
});

const ClubSelectionMobile = ({
    classes,
    renderSkuPrice,
    skuData,
    selectedSku,
    skuMonths,
    changeClubMonth,
    changeClubLength,
    tracker,
    selectedClubUpsells,
    dynamicPriceList,
}) => {
    const skuCollector = [];
    const seed = useUIDSeed();

    const getSlides = () => {
        const slides = [];
        Object.keys(skuMonths).forEach((month) => {
            const monthShort = month.substr(0, 3);
            const currentClubLength = Number(selectedSku.clubLength) || 0;
            const nextMonthSameLength = skuMonths[month].findIndex((monthSku) => Number(monthSku.clubLength) === currentClubLength);
            let changeClubMonthLength = 0;
            if (nextMonthSameLength >= 0) {
                changeClubMonthLength = nextMonthSameLength;
            }
            slides.push(
                <div
                    data-fade={skuMonths[month]?.[0]?.fade}
                    data-testid={`next-selected-${month}-${changeClubMonthLength}-${skuMonths[month]?.[changeClubMonthLength]?.id}`}
                    className={`${skuMonths[month]?.[0]?.isSelectedMonth ? classes.clubSelectedMonth : ''} ${skuMonths[month]?.[0]?.fade ? classes.fadeClubMonth : classes.clubmonth}`}
                    key={seed(month)}
                    onClick={() => { changeClubMonth(skuMonths[month]?.[changeClubMonthLength]); }}
                    data-year={skuMonths[month]?.[0]?.date?.year}
                    tabIndex="0"
                    role="link"
                    onKeyPress={() => { }}
                >
                    {monthShort}
                </div>,
            );
        });
        return slides;
    };

    return (
        <div className={classes.selectionContainer}>
            <p>Please enter the starting month and club length.</p>
            <h3>Starting Month</h3>
            {getSlides().map(((month) => month))}
            <p>Club Length</p>
            <div className={classes.clubSelectionContainer}>
                {skuData.map((sku) => {
                    if (!sku?.clubLength || !sku?.isSelectedMonth) {
                        return null;
                    }
                    if (((skuCollector || []).filter((skuList) => skuList?.length === sku?.clubLength).length)) {
                        return null;
                    }
                    if (selectedClubUpsells) {
                        skuCollector.push({
                            month: sku?.date?.month,
                            length: sku?.clubLength,
                            id: sku?.partNumber,
                        });
                    }
                    return (
                        <div
                            data-id={sku?.legacyId}
                            data-partnumber={sku?.partNumber}
                            data-selected-month={sku?.date?.month}
                            className={selectedSku.id === sku.id ? classes.clubSelectionBoxSelected : classes.clubSelectionBox}
                            key={seed(sku)}
                            onKeyPress={() => { }}
                            onClick={() => {
                                changeClubLength((sku.partNumber || sku.id), sku.id);
                                tracker(sku);
                            }}
                            tabIndex="0"
                            role="link"
                        >
                            <p className={classes.clubDuration}>{sku?.clubLength} Months</p>
                        </div>
                    );
                })}
            </div>
            <p><b>Subtotal: </b>{renderSkuPrice(selectedSku, true, dynamicPriceList ? dynamicPriceList(selectedSku) : null)}</p>
        </div>
    );
};

ClubSelectionMobile.defaultProps = {
    renderSkuPrice: () => { },
    skuMonths: {},
    changeClubMonth: () => { },
    tracker: () => { },
    changeClubLength: () => { },
    classes: {},
    selectedClubUpsells: null,
    dynamicPriceList: null,
};

ClubSelectionMobile.propTypes = {
    classes: object,
    renderSkuPrice: func,
    changeClubMonth: func,
    skuData: skuDataType.isRequired,
    selectedSku: selectedSkuType.isRequired,
    skuMonths: object, // the object contains dynamic keys
    tracker: func,
    changeClubLength: func,
    selectedClubUpsells: string,
    dynamicPriceList: func,
};

export default withStyles(styles)(ClubSelectionMobile);
